module.exports = __webpack_public_path__ + "img/melilla.3333e24b.png";